import {
  useEffect, useRef, useState
} from 'react';
import useSWR from 'swr';

import { swrTaskListFetcher } from '../api_functions/taskListFetch'
import useWorkspaceContext from '../../components/workspaces/WorkspaceContext/WorkspaceContext';

const useTaskList = ({ orchId, orchSha, runLimit = 30 }) => {
  const errorTimeoutRef = useRef(null);
  const [errorMessage, setError] = useState(null);

  const { currentWorkspaceId: workspaceId } = useWorkspaceContext()

  const {
    data, error, isLoading, mutate,
  } = useSWR([orchId, orchSha, workspaceId, runLimit, 'task-list'], swrTaskListFetcher, { refreshInterval: 5000 })

  useEffect(() => {
    if (error) {
      errorTimeoutRef.current = setTimeout(() => {
        setError(error?.message);
      }, 1500);
    } else {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }

    return () => {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }
  }, [error]);

  return {
    taskListData: data,
    error: errorMessage,
    loading: isLoading,
    refetch: mutate,
  };
};
export default useTaskList;
